export const STATUS_ABGESCHLOSSEN = '78A200E4-B303-4589-95EF-0648E518A824';
export const STATUS_AKZEPTIERT = '3675C816-0D3E-4170-9F80-A013247A7CD8';
export const STATUS_DURCHGEFUEHRT = 'DA68D092-DFA0-4E64-97EE-D40D4FCD68BD';
export const STATUS_IN_ARBEIT = '0F40FA6B-FE81-4B13-8D25-182208454906';
export const STATUS_NEUER_TERMIN = 'E6A3CF47-34C5-4627-B41A-24F4A39C8F33';
export const STATUS_NICHT_ANGETROFFEN = '513D199D-76AD-4777-A988-950C8716A5E1';
export const STATUS_OFFEN = '286F29D0-22AC-4B4F-A1D8-BE8B7037E352';
export const STATUS_STORNIERT = '3F9E85AE-2BFA-4C41-80D8-5A3FAE73FF60';
export const STATUS_UEBERFAELLIG = '6A60AC01-9551-447B-B5B7-C4D63AA48F06';
export const STATUS_CUSTOM = 'BEAB5410-4656-4D2A-B6B7-DF510950EF15';
export const STATUS_IM_AUFBAU = '45312345-22AC-4B4F-A1D8-BE8B7037E424';
export const STATUS_GEBUCHT = '57A4008B-2D0E-47C5-9FB8-0B953958527D';
export const STATUS_ABGEGEBEN = '49901300-A9EF-4F13-A5F6-8C07A7C94D81';
export const STATUS_NONE = '00000000-0000-0000-0000-000000000000';
